import { createSelector } from "reselect";
import { isEmpty, forIn } from "lodash";

const defaultPreference = {
  ageStart: 21,
  ageEnd: 27,
  maritalStatus: [],
  religion: [],
  motherTongue: [],
  complexion: [],
  bodyType: [],
  diet: [],
  smoking: [],
  drinking: [],
  state: [],
  country: [],
  education: [],
  employedIn: [],
  jobType: [],
  income: [],
  cache: true
};
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const preference = state.user.partnerPreference;
  //get all static data
  const { data } = state;
  //if any of the static data is empty return the default value
  if (
    isEmpty(data.maritalStatus) ||
    isEmpty(data.bodyType) ||
    isEmpty(data.complexion) ||
    isEmpty(data.diet) ||
    isEmpty(data.habitType) ||
    isEmpty(data.jobType) ||
    isEmpty(data.income) ||
    isEmpty(data.religion)
  ) {
    return defaultPreference;
  }
  //if preference is empty return the default value
  if (isEmpty(preference)) {
    return defaultPreference;
  }
  //format the preference and return it
  try {
    let object = {};
    forIn(preference, (value, key) => {
      if (typeof value === "number") {
        object[key] = value;
      } else if (typeof value === "object" && key !== "updated_at") {
        if (value.all) {
          object[key] = [];
        } else {
          let _data = [];
          forIn(value, (nestedValue, nestedKey) => {
            if (nestedKey !== "all") {
              if (key === "smoking" || key === "drinking") {
                _data.push({
                  value: nestedKey,
                  label: data["habitType"][nestedKey].label,
                  description: data["habitType"][nestedKey].description
                });
              } else if (key === "country" || key === "state") {
                //nothing
              } else {
                if (nestedValue) {
                  _data.push({
                    value: nestedKey,
                    label: data[key][nestedKey].label,
                    description: data[key][nestedKey].description
                  });
                }
              }
            }
          });
          object[key] = _data;
        }
      } else if (key === "updated_at") {
        object[key] = value.toDate();
      }
    });
    return object;
  } catch (error) {
    return defaultPreference;
  }
};
//VERIFY IF THE JWT IS SET
const getMyPartnerPreference = createSelector(
  getData,
  preference => preference
);
export default getMyPartnerPreference;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyPartnerPreference.js